import React from "react";
import SearchLogo from "../../assets/logo (2).svg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF } from "@fortawesome/free-brands-svg-icons";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { Image } from "react-bootstrap";

function Footer() {
  return (
    <footer>
      {/* <div className="footer-content bg-darker text-light wide-container">
        <div className="contact">
          <a
            className="contact-email-link"
            href="tel:+91 22 666 33 555"
            target="_blank"
          >
            +91 22 666 33 555
          </a>
        </div>
        <div className="address">
          <address>
            601 Lodha Supremus, Senapati Bapat Marg, Lower Parel, Mumbai 400013,
            India.
          </address>
        </div>
        <div className="email">
          <a
            className="contact-email-link"
            href="mailto:info@se-arch.com?Subject=Hello"
            target="_blank"
          >
            info@se-arch.com
          </a>
        </div>
      </div> */}
      <div className="footer-bottom wide-container text-dark">
        {/* <a className="brand-logo static text-center" href="index.html">
          <Image
            src={SearchLogo}
            width="178"
            height="33"
            alt="React Bootstrap logo"
          />
        </a> */}
        <div className="text-center">
          Copyright &copy; 2024 Se-Arch. All Rights Reserved
        </div>
        <div className="social">
          <a href="#" target="_blank" title="Facebook">
            <FontAwesomeIcon icon={faFacebookF} className="social-icon" />
          </a>
          <a href="#" target="_blank" title="Linkedin">
            <FontAwesomeIcon icon={faLinkedinIn} className="social-icon" />
          </a>
          <a href="#" target="_blank" title="Instagram">
            <FontAwesomeIcon icon={faInstagram} className="social-icon" />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
